// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  locale: 'it-IT',
  cfUrlImages: 'assets/img/it/',
  cfUrl: 'assets/',
  language: 'it_IT',
  country: 'IT',
  countryId: 39,
  url: 'https://lsr-ui-uat.aws-w-dig-pnl-np-eu-west-1.nielsencsp.com/ui',
  contactUsUrl:
    'https://lsr-ui-dev.aws-w-dig-pnl-np-eu-west-1.nielsencsp.com/ui/itIT/sdp/contactus',
  playStoreUrl:
    'https://play.google.com/store/apps/details?id=com.nielsen.odm&hl=it_IT',
  appleStoreUrl:
    'https://apps.apple.com/it/app/nielsen-mobile-app/id913229909'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
